import { useEffect, useRef, useState } from "react";

const FIRST_DONE_KEY = "prea.firstDoneShown";
const VISIBLE_MS = 7000;

function seen(): boolean {
  try {
    return localStorage.getItem(FIRST_DONE_KEY) === "1";
  } catch {
    return true;
  }
}

/** True for a few seconds after the first task a teammate finishes on this device, once ever. */
export function useFirstDone(running: boolean): boolean {
  const [visible, setVisible] = useState(false);
  const wasRunning = useRef(false);
  useEffect(() => {
    if (running) {
      wasRunning.current = true;
      return;
    }
    if (!wasRunning.current || seen()) return;
    wasRunning.current = false;
    try {
      localStorage.setItem(FIRST_DONE_KEY, "1");
    } catch {
      return;
    }
    setVisible(true);
  }, [running]);
  useEffect(() => {
    if (!visible) return;
    const timer = window.setTimeout(() => setVisible(false), VISIBLE_MS);
    return () => window.clearTimeout(timer);
  }, [visible]);
  return visible;
}
